import React from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

interface StyleSelectionMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  styles: {
    [key: string]: { name: string; style: string; type: string };
  };
  selectedStyle: string;
  onStyleSelect: (style: string) => void;
  isLoadingStyle: boolean;
}

const StyleSelectionMenu: React.FC<StyleSelectionMenuProps> = ({
  anchorEl,
  open,
  onClose,
  styles,
  selectedStyle,
  onStyleSelect,
  isLoadingStyle,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      autoFocus={false}
      slotProps={{
        paper: {
          sx: {
            backdropFilter: 'blur(20px)',
            background: 'rgba(255,255,255,0.7)',
            borderRadius: '12px',
            border: '1px solid rgba(255,255,255,0.3)',
          },
        },
      }}
    >
      {Object.entries(styles).map(([key, style]) => (
        <MenuItem
          key={key}
          onClick={() => onStyleSelect(key)}
          disabled={isLoadingStyle || style?.type === "maintenance"}
        >
          <CheckOutlinedIcon
            sx={{
              mr: 1,
              fontSize: 16,
              color: "primary.main",
              visibility: selectedStyle === key ? "visible" : "hidden",
            }}
          />
          <Typography variant="body2">{style.name}</Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default StyleSelectionMenu;
